module.exports = __webpack_public_path__ + "img/L_7C.076917a8.png";